import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  status: string;
  value: string;
  placeholder?: string;
  styleDef?: any;
  changeEvt: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputBox: FC<Props> = ({ status, placeholder = '', value, changeEvt, styleDef }) => {
  return (
    <div className={['_input_login_box', status].join(' ')}>
      <div className="_input" style={styleDef}>
        <input type="text" placeholder={placeholder} value={value} onChange={e => changeEvt(e)} />
      </div>
    </div>
  );
};

export default InputBox;
